<template>
    <div class="upyield-publisher__page-wrapper min-h-screen">
        <AppNav />
        <main>
            <router-view
                :id="$route.name"
                class="module"
            />
        </main>
    </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import AppNav from '@/components/AppNav';

export default defineComponent({
    name: 'PageWrapper',
    components: {
        AppNav,
    },

    props: {},
});
</script>
